import { wrap } from '@sentry/react-native';
import { ReactNativeWrapperOptions } from '@sentry/react-native/dist/js/options';
import { ComponentType } from 'react';

export default function sentryWrap<P extends Record<string, unknown>>(
  RootComponent: ComponentType<P>,
  options?: ReactNativeWrapperOptions,
) {
  return wrap(RootComponent, options);
}
